import { useQuery } from '@tanstack/react-query';
import { budgetService } from '@services/budget';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import { canReadPendingBudgetRequests } from '@models/user.model';

export const PENDING_BUDGET_REQUESTS_QUERY_KEY = 'pending-budget-requests';

export const usePendingBudgetRequests = (organizationId?: string | null) => {
  const userRole = useAppSelector((state: RootState) => state.user.role);

  return useQuery({
    queryKey: [PENDING_BUDGET_REQUESTS_QUERY_KEY, organizationId],
    queryFn: () => budgetService.getPendingBudgetRequests(),
    // Enforced here (not at each mount site) so every present and future mount is covered: the
    // server refuses this query for every role outside OWNER/ADMIN/PROJECT_MANAGER.
    enabled: !!organizationId && canReadPendingBudgetRequests(userRole),
    staleTime: 0, // Always consider data stale for immediate updates
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
    // No refetchInterval — see useOrganizationEventsSubscription. Budget
    // requests are cross-tenant, so the backend signals the originator and every
    // recipient; each side refetches through its own privacy filter.
    refetchOnMount: 'always', // Always refetch on component mount
    refetchOnWindowFocus: true, // Refetch when user returns to window
    refetchOnReconnect: true, // Refetch when network reconnects
  });
};